export default {
  "DisplayAgreementContents.ListTitle": "同意事項一覧",
  "DisplayAgreementContents.Case": "件/",
  "DisplayAgreementContents.ALLCase": "件中",
  "DisplayAgreementContents.PlaceholderText": "キーワードで探す",
  "DisplayAgreementContents.NoDataText": "同意事項を取得できませんでした",
  "DisplayAgreementContents.NoDataTextPC":
    "ビジネスdアカウントを作成した直後は情報の表示までお時間をいただく場合があります",
  "DisplayAgreementContents.NoDataTextMobile1":
    "ビジネスdアカウントを作成した直後は情報の",
  "DisplayAgreementContents.NoDataTextMobile2":
    "表示までお時間をいただく場合があります",
  "DisplayAgreementContents.BackButton": "トップページへ戻る",
}
